import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  makeStyles,
  Tooltip,
  Typography,
} from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { SPACE } from "config/CONSTANTS";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { classes as workerStyles } from "./AddWorkerStyles";
import { EMPTY, REQUIRED } from "./config";
import { Autocomplete } from "@material-ui/lab";
import { Controller, useFormContext } from "react-hook-form";
import { properCase } from "utils";
const useStyles = makeStyles((theme) => workerStyles(theme));

export const UserIds = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    system,
    workerRoles,
    setWorkerRoles,
    regions,
    selectedRegion,
    setSelectedRegion,
    validateWorkerRoles,
  } = props;

  const isSelected = (name) =>
    workerRoles &&
    workerRoles[system] &&
    workerRoles[system][name] &&
    workerRoles[system][name]["isActive"];

    const getWorkerRole = (name) =>
    workerRoles &&
    workerRoles[system] &&
    workerRoles[system][name] &&
    workerRoles[system][name]["role"];
    

  const getWorkerField = (name, field) =>
    workerRoles &&
    workerRoles[system] &&
    workerRoles[system][name] &&
    workerRoles[system][name][field]
      ? workerRoles[system][name][field]
      : "";

  const handleUserAccessChange = (event, system, name) => {
    const target = event.target;
    
    let value = target.id.endsWith("UserActive")
      ? target.checked
      : target.value;
    if (!workerRoles[system]) {
      workerRoles[system] = {};
    }

    if (!workerRoles[system][name]) {
      workerRoles[system][name] = {
        activityFamilyId: system,
        region: name,
      };
    }
    
   if(target.id.endsWith("UserActive"))
    {
      workerRoles[system][name]["isActive"] = target.checked;
      workerRoles[system][name]["error"] = EMPTY;
    }
    else if(target.id.endsWith("UserId"))
    {
      if (target.value && target.value !== null) {
           workerRoles[system][name]["userId"] = value.trim();
            workerRoles[system][name]["error"] = EMPTY;
          } else {
            workerRoles[system][name]["userId"] = EMPTY;
            workerRoles[system][name]["error"] = REQUIRED;
          }
    }else if(!target.id.endsWith("UserActive") && !target.id.endsWith("UserId"))
    {
      workerRoles[system][name]["role"] =  target.value;
    }
    validateWorkerRoles();
    setWorkerRoles((state) => ({ ...state, [system]: workerRoles[system] }));
  };

  const accordion = {
    width: "90%",
    marginLeft: "15px",
    marginTop: "10px",
  };

  const checkbox = {
    paddingRight: 0,
    paddingTop: 16,
  };

  const handleChange = (system) => (event) => {
    const target = event.target;
    setSelectedRegion((state) => ({ ...state, [system]: target.value }));
    target.value.forEach((region) => {
      if (!workerRoles[system]) {
        workerRoles[system] = {};
      }

      if (workerRoles[system] && !workerRoles[system][region]) {
        workerRoles[system][region] = {
          activityFamilyId: system,
          region: region,
          isActive: true,
        };
      }else if(workerRoles[system] && workerRoles[system][region]) {
        workerRoles[system][region]['isActive'] = true;
      }
    });

    if(selectedRegion && selectedRegion[system] && Array.isArray(selectedRegion[system])){
      selectedRegion[system].forEach(region => {
        if(!target.value.includes(region)){
          if (workerRoles[system] && workerRoles[system][region]) {
            workerRoles[system][region]['isActive'] = false;
          }
        }
      })
    }
    validateWorkerRoles();
  };

  return (
    <>
      <FormControl className={classes.userAccessControl}>
        <InputLabel>{system + t("pgAddWorker.lbluserAccess")}</InputLabel>
        <Select
          id={system}
          name={system + " User Access"}
          multiple
          value={selectedRegion[system]}
          onChange={handleChange(system)}
        >
          {regions.map((name) => (
            <MenuItem key={name} value={name}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {selectedRegion &&
      selectedRegion[system] &&
      selectedRegion[system].length > 0 ? (
        <Accordion defaultExpanded style={accordion}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={system - selectedRegion[system] + "content"}
            id={system - selectedRegion[system] + "-header"}
          >
            <Typography className={classes.color}>
              {system.toUpperCase()} User IDs
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ paddingTop: "0px" }}>
            <Grid container direction="row">
              {selectedRegion[system].map((name) => (
                <Grid item xs={12} key={name}>
                  <FormControl className={classes.userControl}>
                  <Grid container direction="row">
                      <Grid item xs={10} key={name}>
                        <TextField
                          id={system + name + "UserId"}
                          name={system + SPACE + name + " UserId "}
                          defaultValue={getWorkerField(name, "userId")}
                          required
                          error={!!getWorkerField(name, "error")}
                          helperText={getWorkerField(name, "error")}
                          onChange={(event) =>
                            handleUserAccessChange(event, system, name)
                          }
                          onBlur={(event) =>
                            handleUserAccessChange(event, system, name)
                          }
                          label={name + t("pgAddWorker.lbluserId")}
                          InputProps={{
                            className: classes.name,
                          }}
                          FormHelperTextProps={{
                            className: classes.formHelperText,
                          }}
                          value={getWorkerField(name, "userId")}
                          disabled={!isSelected(name)}
                        />
                      </Grid>
                      <Grid item xs={2} key={name}>
                        <Tooltip
                          title={
                            (isSelected(name)
                              ? t("pgAddWorker.lblDisable")
                              : t("pgAddWorker.lblEnable")) +
                            t("pgAddWorker.lblAccessForRegion")
                          }
                          aria-label="isActive"
                        >
                          <Checkbox
                            color="primary"
                            id={system + name + "UserActive"}
                            name={system + name + "UserActive"}
                            value={isSelected(name)}
                            checked={isSelected(name)}
                            style={checkbox}
                            onChange={(event) =>
                              handleUserAccessChange(event, system, name)
                            }
                          />
                        </Tooltip>
                      </Grid>
                      {
                      system.toUpperCase() == 'SKP' &&
                        <Autocomplete
                        id={system + name + "SKPRole"}
                        defaultValue={getWorkerRole(name, "role")}
                        options={["Worker", "Project Manager", "Supervisor","Administrator"]}
                       // getOptionLabel={(option) => option.label}
                        style={{ width: "10vw" }}
                        value={props.value}
                       // value={getWorkerRole(name, "role")}
                        onChange={(event) =>
                          handleUserAccessChange(event, system, name)
                        }
                        onBlur={(event) =>
                          handleUserAccessChange(event, system, name)
                        }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              label={t( "other.lblSelectRole" )}
                              id={system + name + "SKPRole"}
                              name={system + name + "SKPRole"}
                              onBlur={(event) =>
                                handleUserAccessChange(event, system,name )
                              }
                            />
                          )}
                        // value={contingentWorker.currencies[0]}
                        />
                       }
                     </Grid> 
                  </FormControl>
                </Grid>
              ))}
            </Grid>
            </AccordionDetails>
            
        </Accordion>
      ) : (
        <></>
      )}
    </>
  );
};

UserIds.propTypes = {
  system: PropTypes.string.isRequired,
  regions: PropTypes.array.isRequired,
  selectedRegion: PropTypes.object.isRequired,
  setSelectedRegion: PropTypes.func.isRequired,
  workerRoles: PropTypes.object,
  setWorkerRoles: PropTypes.func.isRequired,
  validateWorkerRoles: PropTypes.func.isRequired,
};

export default UserIds;
